export interface ReportDirectoryEntry { id: string; title: string; level?: number; group?: string; }

interface ReportDirectoryProps {
  entries: ReportDirectoryEntry[];
  activeId?: string;
  onSelect?: (id: string) => void;
  collapsed: boolean;
  onCollapsedChange: (collapsed: boolean) => void;
}

function groupClass(group?: string): string {
  if (group === "综合财务分析") return "is-comprehensive";
  if (group === "财务风险识别") return "is-risk";
  if (group === "行业经营对标") return "is-benchmark";
  return "is-plain";
}

function groupEntries(entries: ReportDirectoryEntry[]): Array<{ group?: string; entries: ReportDirectoryEntry[] }> {
  return entries.reduce<Array<{ group?: string; entries: ReportDirectoryEntry[] }>>((groups, entry) => {
    const current = groups.at(-1);
    if (!current || current.group !== entry.group) groups.push({ group: entry.group, entries: [entry] });
    else current.entries.push(entry);
    return groups;
  }, []);
}

export function ReportDirectory({ entries, activeId, onSelect, collapsed, onCollapsedChange }: ReportDirectoryProps) {
  return <nav className={`fa-report-directory${collapsed ? " is-collapsed" : ""}`} aria-label="报告目录">
    <div className="fa-report-directory__top">
      <div className="fa-report-directory__title">报告目录</div>
      <button type="button" className="fa-report-directory__toggle" aria-label={collapsed ? "展开目录" : "收起目录"} title={collapsed ? "展开目录" : "收起目录"} onClick={() => onCollapsedChange(!collapsed)}>{collapsed ? "›" : "‹"}</button>
    </div>
    {!collapsed && <div className="fa-report-directory__groups">{groupEntries(entries).map((directoryGroup, index) => <section className={`fa-report-directory__group-block ${groupClass(directoryGroup.group)}`} key={`${directoryGroup.group ?? "plain"}-${index}`}>
      {directoryGroup.group && <header className="fa-report-directory__group-heading"><span>{directoryGroup.group}</span><em>{directoryGroup.entries.length} 份报告</em></header>}
      <div className="fa-report-directory__group-items">{directoryGroup.entries.map((entry) => {
        const depth = Math.max(0, (entry.level ?? 1) - 1);
        return <button type="button" className="fa-report-directory__item" style={{ paddingLeft: `${32 + depth * 12}px` }} aria-current={entry.id === activeId ? "true" : undefined} onClick={() => onSelect?.(entry.id)} key={entry.id}>{entry.title}</button>;
      })}</div>
    </section>)}</div>}
  </nav>;
}
